import { PropsWithChildren, ReactElement } from 'react';
import { Stack } from '@mui/material';
import { useIsMobile } from '@synergy/components-next';

export const EmptyStateActions = (props: PropsWithChildren): ReactElement => {
    const isMobile = useIsMobile();

    return (
        <Stack
            direction={isMobile ? 'column' : 'row-reverse'}
            justifyContent="center"
            spacing={2}
            sx={{ width: isMobile ? '270px' : '480px', mt: 2.5 }}
        >
            {props.children}
        </Stack>
    );
};
